//  Package imports.
import { Map as ImmutableMap } from "immutable";

//  Our imports.
import { LOCAL_SETTING_CHANGE, LOCAL_SETTING_DELETE } from "flavours/glitch/actions/local_settings";
import { applyRemoteValues, LOCAL_SETTINGS_SYNC_APPLY, LOCAL_SETTINGS_SYNC_DISABLE, LOCAL_SETTINGS_SYNC_STAMP, registerSyncDefaults } from "flavours/glitch/actions/settings_sync";
import { STORE_HYDRATE } from "flavours/glitch/actions/store";

export const initialState = ImmutableMap({
  layout    : "single",
  stretch   : true,
  show_reply_count : false,
  always_show_spoilers_field: true,
  confirm_missing_media_description: false,
  confirm_boost_missing_media_description: false,
  confirm_before_clearing_draft: true,
  prepend_cw_re: false,
  preselect_on_reply: false,
  inline_preview_cards: true,
  embed_video_links: false,
  hicolor_privacy_icons: false,
  favourite_stars: false,
  system_font: false,
  font_size: "standard",
  // Comma-separated language codes hidden in public timelines (filter_generator.jsx).
  hidden_languages: "",
  // Comma-separated timeline groups without bot posts (utils/hidden_languages.js).
  hide_bots: "",
  // "You're caught up" marker in the home timeline (utils/read_marker.js).
  read_marker: true,
  show_content_type_choice: true,
  tag_misleading_links: true,
  rewrite_mentions: "no",
  content_warnings : ImmutableMap({
    auto_unfold  : false,
    filter       : null,
    media_outside: true,
    shared_state : true,
  }),
  collapsed : ImmutableMap({
    enabled     : false,
    auto        : ImmutableMap({
      all              : false,
      notifications    : false,
      lengthy          : true,
      reblogs          : false,
      replies          : false,
      media            : false,
      height           : 400,
    }),
    show_action_bar : true,
  }),
  media     : ImmutableMap({
    use_blurhash     : true,
    preview_only     : false,
    autoplay_muted   : true,
    letterbox        : false,
    fullwidth        : true,
    show_alt_badge   : true,
    reveal_behind_cw : false,
    pop_in_player    : true,
    pop_in_position  : "right",
  }),
  notifications : ImmutableMap({
    favicon_badge : false,
    tab_badge     : true,
  }),
  status_icons : ImmutableMap({
    language:   true,
    reply:      true,
    local_only: true,
    media:      true,
    visibility: true,
  }),
  navigation_order: "",
  navigation_hidden: "",
  sync_settings: false,
  sync_updated_at: 0,
  theme: "mastodon-light",
  palette: "moss",
});

registerSyncDefaults(initialState);

const hydrate = (state, localSettings) => state.mergeDeep(localSettings);

export default function localSettings(state = initialState, action) {
  switch(action.type) {
    case STORE_HYDRATE:
      return hydrate(state, action.state.get("local_settings"));
    case LOCAL_SETTING_CHANGE:
      return state.setIn(action.key, action.value);
    case LOCAL_SETTINGS_SYNC_APPLY:
      return applyRemoteValues(initialState, action.values, state).set("sync_updated_at", action.updatedAt);
    case LOCAL_SETTINGS_SYNC_DISABLE:
      return state.set("sync_settings", false);
    case LOCAL_SETTINGS_SYNC_STAMP:
      return state.set("sync_updated_at", action.updatedAt);
    case LOCAL_SETTING_DELETE:
      return state.deleteIn(action.key);
    default:
      return state;
  }
}
